<template>
  <section
    class="d-flex justify-content-center flex-column"
    style="height: 100vh"
    fluid
  >
    <div class="row w-100 mx-auto">
      <b-form
        @submit.prevent="onSubmit"
        v-if="show"
        class="col-12 col-md-6 col-lg-3 mx-auto"
      >
        <h3 class="text-center">Connexion</h3>
        <b-form-group id="input-group-email">
          <ValidationProvider rules="required|email" v-slot="validationContext">
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              placeholder="Votre email greenweez"
              autocomplete="email"
              :state="getValidationState(validationContext)"
              aria-describedby="email-input-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="email-input-live-feedback">{{
              validationContext.errors[0]
            }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <b-form-group id="input-group-password">
          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-input
              type="password"
              id="text-password"
              v-model="form.password"
              placeholder="Votre mot de passe"
              autocomplete="current-password"
              :state="getValidationState(validationContext)"
              aria-describedby="password-input-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="password-input-live-feedback">{{
              validationContext.errors[0]
            }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <div class="text-center">
          <gwz-button submitButtonText="Valider" />
        </div>
      </b-form>
    </div>
  </section>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import GwzButton from "@/components/gwzButton";

// No message specified.
extend("email", {
  ...email,
  message: "Votre email n'est pas valide"
});

// Override the default message.
extend("required", {
  ...required,
  message: "Ce champ est obligatoire"
});

export default {
  components: {
    ValidationProvider,
    GwzButton
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      show: true,
      error: "",
      validationContext: {},
      message: ""
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      this.$store.dispatch("users/login", this.form);
    }
  }
};
</script>

<style></style>
